import { Component, OnInit } from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {SharedService} from "../../modules/shared/services/shared.service";
import {MemberService} from "../../modules/account/services/member.service";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private memberService: MemberService
  ) {
    this.spinner.show();
  }

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.memberService.clearMembershipCache();
    this.sharedService.logout();
  }

}
